import { cn } from "~/lib/utils";

interface TooltipContainerProps extends React.PropsWithChildren {
    className?: string;
}
export function TooltipContainer({ children, className }: TooltipContainerProps) {
    return (
        <div
            className={cn(className, "font-metadata-small z-20 max-w-xs bg-gray-80 p-1 text-white")}
        >
            {children}
        </div>
    );
}
